export const websocketUrl =
  localStorage.getItem('posServerIp') || 'ws://127.0.0.1:8001';

export const OPERATION = {
  SALE: 'sale',
  VOID: 'void',
  REFUND: 'refund',
  SETTLEMENT: 'settlement',
  READ_CARD: 'readCard',
  ABORT: 'abort',
  DIALOG: 'dialog',
  REPORT: 'report',
  PRE_AUTH: 'preAuth',
  COMPLETE: 'complete',
};

export const generateCRN = () => Math.floor(Math.random() * 1000000000);

export const ecrNameVersion = 'GreetKiosk ver.1.0';
